/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Twittertitle1Inputs */

const ja_metadata_twittertitle1 = /** @type {(inputs: Metadata_Twittertitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`@PlayBrainHQ`)
};

const en_metadata_twittertitle1 = /** @type {(inputs: Metadata_Twittertitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`@PlayBrainHQ`)
};

/**
* | output |
* | --- |
* | "@PlayBrainHQ" |
*
* @param {Metadata_Twittertitle1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const metadata_twittertitle1 = /** @type {((inputs?: Metadata_Twittertitle1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Twittertitle1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_metadata_twittertitle1(inputs)
	return en_metadata_twittertitle1(inputs)
});
export { metadata_twittertitle1 as "metadata_twitterTitle" }